import { mergeWith } from 'lodash'
import React from 'react'

function PromotionButton({ btn }) {
    return (
      <div
        key={btn.btnName}
        className="btn-container"
        style={btn.style}
        onClick={btn.btnAction} // Call the action when clicked
      >
        <div className="btn-label">{btn?.btnName}</div>
      </div>
    );
  }
  
function AppliedHistoryCardOneWallet({ Config }) {
console.log("AppliedHistoryCardOneWalletconfig", Config);
let DefaultConfig = {
    title: "Tổng số dư",
    promotionIcon: "/vn/img/1wallet/00/info.svg",
    promotionName: "1Wallet",
    promotionAmount: 1000000,
    promotionDate: "2021-04-23",
    btns: [
    {
        btnName: "Rút tiền",
        btnIcon: "/vn/img/1wallet/00/withdraw.svg",
        btnAction: () => console.log("Withdraw action"), // Example action
        style: {
        color: "red",
        },
    },
    {
        btnName: "Chi tiết",
        btnIcon: "/vn/img/1wallet/00/detail.svg",
        btnAction: () => console.log("View details action"), // Example action
        style: {
        color: "blue",
        },
    },
    ],
};

let DataObject = mergeWith(DefaultConfig, Config);

return (
    <div className="applied-history-card">
    <div className="card-header">
        <div className="card-title">{DataObject?.title}</div>
        {DataObject.promotionIcon && (
        <img
            className="card-icon"
            src={DataObject?.promotionIcon}
            alt={DataObject?.promotionName}
        />
        )}
    </div>
    <div className="card-body">
        <div className="promotion-info">
        <div className="promotion-name">{DataObject?.promotionName}</div>
        <div className="promotion-amount">{`${DataObject?.promotionAmount} đ`}</div>
        </div>
        <div className="promotion-expiry">
        <div className="expiry-label">Thời gian kết thúc Khuyến mãi</div>
        <div className="expiry-date">{DataObject?.promotionDate}</div>
        </div>
    </div>
    <div className="card-footer">
        <div className="button-container">
        {DataObject?.btns.map((btn, index) => (
            <React.Fragment key={index}>
            {index > 0 && <div className="divider"></div>}
            <PromotionButton btn={btn} />
            </React.Fragment>
        ))}
        </div>
    </div>
    </div>
);
}

export default AppliedHistoryCardOneWallet;
